// extracted by mini-css-extract-plugin
module.exports = {"content":"Product_content__2LdHg","submitBtn":"Product_submitBtn__O7jxO"};